import Cookies from "js-cookie";
// Function to get data from localStorage
function get6senseIndustry() {
    let companyData = localStorage.getItem("_6senseCompanyDetails");

    if (companyData) {
        try {
            let parsedData = JSON.parse(companyData);
            if (parsedData.company && parsedData.company.industry) {
                return parsedData.company.industry;
            }
        } catch (e) {
            console.error("Error parsing 6sense company data:", e);
        }
    }
    return null;
}

function updateIndustryCookie() {
    let industry = get6senseIndustry();
    let existingIndustry = Cookies.get("industryC");

    if (industry && industry !== existingIndustry) {
        Cookies.set("industryC", industry, 30);
    }
}

export default updateIndustryCookie;
